import ReactDOM from 'react-dom';
import { ua } from '../ua';
import Content from './Content';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { CSSProperties, useCallback, useEffect, useMemo, useState } from 'react';
import H5Title from '../document-title/H5Title';
import { weappSDK } from '../sdk';
import appInfo from '../appInfo';
import { getLabel } from '../locale';
export { registerTip } from './registerTip';

export const BATCH_TIP_CONTAINER = 'batchtask-tip-container';
const tipWrapHeight = 56;
const h5WrapHeight = 35;
let rootStyle: CSSProperties = {};
let isTiping = false;
let batchList: any[] = [];
const h5Title = new H5Title();
export const successBatchTip = (data: any = {}) => {
  const { content } = data;
  if (ua.device === 'PC' && window.weappUi?.Dialog?.message) {
    window.weappUi.Dialog.message({
      type: 'success',
      delay: 10000,
      content,
    });
  } else if (ua.device === 'Mobile') {
    renderH5Tip(data);
  }
};

export const failureBatchTip = (data: any = {}) => {
  if (ua.device === 'PC' && window.weappUi?.Dialog?.message) {
    batchList.push(data);
    if (!isTiping && batchList.length) {
      isTiping = true;
      runTask();
    }
  } else if (ua.device === 'Mobile') {
    renderH5Tip(data);
  }
};

export const runTask = () => {
  if (batchList.length) {
    const task = batchList.shift();
    const { content, taskId } = task;
    const obj = window.weappUi.Dialog.message({
      type: 'info',
      content: <Content content={content} taskId={taskId} destroy={() => obj.destroy} />,
      delay: 0,
      destroy() {
        isTiping = false;
        runTask();
      },
    });
  }
};

const BatchTaskViewDialog = (props: any) => {
  const { taskId, randomId } = props;
  const CorsComponent = window?.weappUi?.CorsComponent;
  const [show, setShow] = useState(true);
  const handleClose = useCallback(() => {
    setShow(false);
  }, []);
  useEffect(() => {
    setShow(true);
  }, [taskId, randomId]);
  return (
    <CorsComponent
      app='@weapp/uibusiness'
      compName='BatchTaskViewDialog'
      visible={show}
      idFromParent={taskId}
      onClose={handleClose}
    />
  );
};

export const render = (taskId: string) => {
  const wrapDom = document.getElementById(BATCH_TIP_CONTAINER);
  if (!wrapDom) {
    let dom = document.createElement('div');
    dom.id = BATCH_TIP_CONTAINER;
    document.body.append(dom);
  }
  const randomId = Math.random();
  ReactDOM.render(
    <Router>
      <Route path={window.location.pathname}>
        <BatchTaskViewDialog taskId={taskId} randomId={randomId} />
      </Route>
    </Router>,
    document.getElementById(BATCH_TIP_CONTAINER)
  );
};

const H5Content = (props: any) => {
  const { success, content, taskId } = props;
  const Icon = window?.weappUi?.Icon;
  const mobdileStyle = useMemo(() => {
    return {
      display: 'flex',
    };
  }, []);
  const handleClick = useCallback(() => {
    unRegister();
    weappSDK.openLink({ url: `${appInfo('@weapp/utils').publicUrl}/mobile/uibusiness/batchTask/detail/${taskId}` });
  }, [taskId]);

  const detailBtnStyle = useMemo(() => {
    return {
      marginLeft: '6px',
      color: 'var(--primary)',
      lineHeight: '18px',
    };
  }, []);

  const getString = useCallback((val: string = '') => {
    let len = 0;
    let index = 0;
    for (let i = 0; i < val.length; i++) {
      let c = val.charCodeAt(i);
      if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
        len++;
      } else {
        len += 2;
      }
      if (len >= 80) {
        index = i;
        break;
      }
    }
    return len >= 80 ? val.substring(0, index) + '...' : val;
  }, []);
  return (
    <>
      <div style={mobdileStyle}>
        <Icon
          name={success ? 'Icon-complete' : 'Icon-remind04'}
          size='xs'
          style={{ color: success ? 'var(--success)' : 'var(--warning)', marginTop: 2 }}
        ></Icon>
        <span style={{ margin: '0 4px', lineHeight: '18px', flex: '1 1 auto', position: 'relative' }}>
          <span
            style={{
              display: 'inline-block',
              height: '36px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              wordBreak: 'break-word',
            }}
          >
            {success ? content : getString(content)}
            {!success && (
              // @ts-ignore
              <span style={detailBtnStyle} onClick={handleClick}>
                {getLabel('119011', '查看详情')}
              </span>
            )}
          </span>
        </span>
        {!success && (
          <div style={{ margin: '-5px', padding: '7px 5px' }} onClick={unRegister}>
            <Icon name={'Icon-error01'} size='xxs' />
          </div>
        )}
      </div>
    </>
  );
};

export const adjustStandardStyle = () => {
  const rootDom = window.document.getElementById('root');
  const isH5 = h5Title.hasRegister() && window?.document?.title;
  const wraperHeight = isH5 ? h5WrapHeight + tipWrapHeight : tipWrapHeight;
  if (!('paddingTop' in rootStyle))
    rootStyle = {
      paddingTop: rootDom?.style.paddingTop,
    };
  rootDom && (rootDom.style.paddingTop = `${wraperHeight}px`);
};

export const recoverStandardStyle = () => {
  const rootDom = window.document.getElementById('root');
  rootDom && (rootDom.style.paddingTop = rootStyle?.paddingTop + '' || '');
  rootStyle = {};
};

// 渲染函数
export const renderH5Tip = (data: any = {}) => {
  const { content = '', taskId = '', success } = data;
  const wrapDom = document.getElementById(BATCH_TIP_CONTAINER);
  if (!wrapDom) {
    let wrapDom = document.createElement('div');
    wrapDom.id = BATCH_TIP_CONTAINER;
    // 定位
    wrapDom.style.position = 'fixed';
    wrapDom.style.zIndex = '999';
    wrapDom.style.top = h5Title.hasRegister() && window?.document?.title ? '35px' : '0';
    wrapDom.style.left = '0px';

    // 字体大小跟随全局设置
    wrapDom.style.fontSize = 'var(--font-size-sm)';
    wrapDom.style.background = success ? 'rgb(232, 249, 224)' : 'rgb(255, 243, 220)';

    // 定高(56px)
    wrapDom.style.height = `56px`;
    wrapDom.style.lineHeight = `var(--font-size-lg)px`;
    wrapDom.style.textAlign = 'center';
    wrapDom.style.padding = '10px';
    wrapDom.style.width = '100%';
    wrapDom.style.textAlign = 'left';

    document.body.appendChild(wrapDom);
  }
  adjustStandardStyle();
  ReactDOM.render(
    <>
      <H5Content content={content} taskId={taskId} success={success} />
    </>,
    document.getElementById(BATCH_TIP_CONTAINER)
  );
  // 十秒之后自动卸载
  success &&
    setTimeout(() => {
      unRegister();
    }, 10000);
};

// 卸载函数
export const unRegister = () => {
  recoverStandardStyle();
  const wrapDom = document.getElementById(BATCH_TIP_CONTAINER);
  if (wrapDom) {
    const unmount = ReactDOM.unmountComponentAtNode(wrapDom);
    if (unmount && wrapDom.parentNode) {
      wrapDom.parentNode.removeChild(wrapDom);
    }
  }
};
